// import { createSlice } from "@reduxjs/toolkit";

// // @ts-ignore
// import {
//   // getAllWholesalerCommunity,
//   // getAllWholesalerCommunityWithoughtId,
//   getStoryProductById,
//   getStoryProductList,
//   getAllStoryProductList,
// } from "./ThunkActions";

// // @ts-ignore
// import { iStoryProductState, REDUCER_NAME } from "./Types";

// // Define initial state
// const initialState: iStoryProductState = {
//   isLoading: false,
//   storyProductDetail: null,
//   storyProductList: [],
//   errorMessage: null,
//   wholesalerStoryProduct: [],
//   wholesalerStoryProductById: [],
// };

// export const storyProductSlice = createSlice({
//   name: REDUCER_NAME,
//   initialState,
//   reducers: {
//     resetStoryProductState: () => initialState,
//   },
//   extraReducers: (builder) => {
//     builder
//       // Get Story Product By ID
//       .addCase(getStoryProductById.pending, (state) => {
//         state.isLoading = true;
//       })
//       .addCase(getStoryProductById.fulfilled, (state, action) => {
//         const payload = action.payload;
//         if (payload && payload.data) {
//           console.log(action.payload, "action.payload");
//           state.storyProductDetail = payload.data.story;
//         }
//         state.isLoading = false;
//       })
//       .addCase(getStoryProductById.rejected, (state) => {
//         state.errorMessage = "Failed to fetch Community data";
//         state.isLoading = false;
//       })

//       // Get Story Product List
//       .addCase(getStoryProductList.pending, (state) => {
//         state.isLoading = true;
//       })
//       .addCase(getStoryProductList.fulfilled, (state, action) => {
//         const payload = action.payload;
//         if (payload && payload.data) {
//           state.storyProductList = payload.data.stories;
//         }
//         state.isLoading = false;
//       })
//       .addCase(getStoryProductList.rejected, (state) => {
//         state.errorMessage = "Failed to fetch Community data";
//         state.isLoading = false;
//       })

//       // ✅ Get All Story Product List
//       .addCase(getAllStoryProductList.pending, (state) => {
//         state.isLoading = true;
//       })
//       .addCase(getAllStoryProductList.fulfilled, (state, action) => {
//         const payload = action.payload;
//         if (payload && payload.data) {
//           state.storyProductList = payload.data;
//         }
//         state.isLoading = false;
//       })
//       .addCase(getAllStoryProductList.rejected, (state, action) => {
//         // @ts-expect-error
//         state.errorMessage = action.payload?.message || "Failed to fetch story product list";
//         state.isLoading = false;
//       });

//     // Uncomment these if you need wholesaler community
//     /*
//     .addCase(getAllWholesalerCommunity.pending, (state) => {
//       state.isLoading = true;
//     })
//     .addCase(getAllWholesalerCommunity.fulfilled, (state, action) => {
//       const payload = action.payload;
//       if (payload && payload.data) {
//         state.wholesalerStoryProductById = payload.data.communities;
//       }
//       state.isLoading = false;
//     })
//     .addCase(getAllWholesalerCommunity.rejected, (state) => {
//       state.errorMessage = "Failed to fetch Community data";
//       state.isLoading = false;
//     })

//     .addCase(getAllWholesalerCommunityWithoughtId.pending, (state) => {
//       state.isLoading = true;
//     })
//     .addCase(getAllWholesalerCommunityWithoughtId.fulfilled, (state, action) => {
//       const payload = action.payload;
//       if (payload && payload.data) {
//         state.wholesalerStoryProduct = payload.data.communities;
//       }
//       state.isLoading = false;
//     })
//     .addCase(getAllWholesalerCommunityWithoughtId.rejected, (state) => {
//       state.errorMessage = "Failed to fetch Community data";
//       state.isLoading = false;
//     })
//     */
//   },
// });

// export const { resetStoryProductState } = storyProductSlice.actions;
// export default storyProductSlice.reducer;





import { createSlice } from "@reduxjs/toolkit";

// @ts-ignore
import {
  getStoryProductById,
  getStoryProductList,
  getAllStoryProductList,
  createStoryProduct,
} from "./ThunkActions";

// @ts-ignore
import { iStoryProductState, REDUCER_NAME } from "./Types";

const initialState: iStoryProductState = {
  isLoading: false,
  storyProductDetail: null,
  storyProductList: [],
  errorMessage: null,
  wholesalerStoryProduct: [],
  wholesalerStoryProductById: [],
  successMessage: null,
};

export const storyProductSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetStoryProductState: () => ({
      ...initialState,
    }),
  },
  extraReducers: (builder) => {
    builder
      // ✅ Get Story Product By ID
      .addCase(getStoryProductById.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getStoryProductById.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload?.data) {
          state.storyProductDetail = payload.data.story;
        }
        state.isLoading = false;
      })
      .addCase(getStoryProductById.rejected, (state) => {
        state.errorMessage = "Failed to fetch Story Product by ID";
        state.isLoading = false;
      })

      // ✅ Get Story Product List (limited)
      .addCase(getStoryProductList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getStoryProductList.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload?.data) {
          state.storyProductList = payload.data.stories;
        }
        state.isLoading = false;
      })
      .addCase(getStoryProductList.rejected, (state) => {
        state.errorMessage = "Failed to fetch Story Product list";
        state.isLoading = false;
      })

      // ✅ Get All Story Product List (admin/global list)
      .addCase(getAllStoryProductList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllStoryProductList.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload?.data) {
          state.storyProductList = payload.data;
        }
        state.isLoading = false;
      })
      .addCase(getAllStoryProductList.rejected, (state, action) => {
        // @ts-expect-error
        state.errorMessage = action.payload?.message || "Failed to fetch all story products";
        state.isLoading = false;
      })

      // ✅ Create Story Product
      .addCase(createStoryProduct.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createStoryProduct.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload?.data) {
          state.storyProductList.unshift(payload.data); 
         
          state.successMessage = payload.message ?? "Story Product created successfully";
        }
        state.isLoading = false;
      })
      .addCase(createStoryProduct.rejected, (state, action) => {
        // @ts-expect-error
        state.errorMessage = action.payload?.message || "Failed to create story product";
        state.isLoading = false;
      });
  },
});

export const { resetStoryProductState } = storyProductSlice.actions;
export default storyProductSlice.reducer;
